export default __webpack_public_path__ + "static/media/influencer-1.ca016e04.webp";